import React from 'react'
import {Field, Fields, reduxForm} from 'redux-form'
import CourseCategories from "./CourseCategories";
import ShowContactPerson from "../contact-person/ShowContactPerson";
import CourseDates from "./CourseDates";
import SubmitButton from '../common/SubmitButton';
import Price from "../common/Price";
import ValidatedInputField from '../common/form/ValidatedInputField';
import VideoUploadRedux from '../VideoUploadRedux';
import FileUpload from '../files/FileUpload';
import Wrapper from '../common/form/Wrapper';
import ValidatedWrappedInputField from '../common/form/ValidatedWrappedInputField';
import GeoLocation from '../common/GeoLocation';
import Municipality from "../company/Municipality";
import CompanyAddress from "../company/CompanyAddress";
import normalizePostalCode from "../../normalizers/normalizePostalCode";
import Regions from "../company/Regions";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import {validate} from './validate';
import MultistepSelectFormAdapter from '../common/MultistepSelectFormAdapter';
import DropDownOptions from '../helpers/DropDownOptions';
import ReactSelect from '../common/ReactSelect';
import RteEditor from "../common/form/RteEditor";
import afterSubmitFail from '../common/form/focusAfterSubmitFail';
import ResetButton from "../common/ResetButton";

let CourseFormRedux = props => {
    const {
        handleSubmit,
        handleModalClick,
        handleReset,
        countries,
        regions,
        municipalities,
        addressSearchResult,
        contactPersons,
        categories,
        isUpdate,
        initialValues,
        types,
        intl
    } = props;

    let imageSizeLimit = (MAX_IMAGE_SIZE > 1) ? MAX_IMAGE_SIZE - 1 : 1;
    let fileSizeLimit = (MAX_FILE_SIZE > 1) ? MAX_FILE_SIZE - 1 : 1;

    return (
        <form onSubmit={handleSubmit} noValidate={true}>
            <Field
                className="form-control"
                name="name"
                type="text"
                component={ValidatedInputField}
                label={intl.formatMessage(messages.heading)}
            />
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.type)}</b>
                </label>
                <div className="col-sm-10">
                    <Field
                        type="select"
                        name="typeId"
                        component={ReactSelect}
                        options={DropDownOptions.getOptions(types, 'id', 'title')}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.contactPerson)}</b>
                </label>
                <div className="col-sm-10">
                    <Field
                        type="select"
                        name="contactPersonId"
                        component={ReactSelect}
                        options={DropDownOptions.getOptions(contactPersons, 'id', 'name')}
                        placeholder={intl.formatMessage(messages.contactPersonSelect)}
                    />
                    <Field
                        type="button"
                        name="showModal"
                        onChage={handleModalClick}
                        component={ShowContactPerson}
                        props={{
                            handleModalClick: handleModalClick,
                            text: intl.formatMessage(messages.courseContactPersonDescription)
                        }}
                    />
                </div>
            </div>
            <Field
                name='categoryIds'
                component={MultistepSelectFormAdapter}
                data={categories}
                maxCount={1}
            />
            <Fields
                type="datePicker"
                names={['startDate', 'endDate']}
                component={CourseDates}
            />
            <hr/>

            <Wrapper label={intl.formatMessage(messages.country)} inputCol={3}>
                <Field
                    type="select"
                    name="countryId"
                    component={ReactSelect}
                    options={DropDownOptions.getOptions(countries, 'id', 'name')}
                />
            </Wrapper>
            <div className="form-group row" id="div_regionId">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.region)}</b>
                </label>
                <div className="col-sm-10">
                    <Field
                        name="regionId"
                        component={Regions}
                        regions={regions}
                    >
                    </Field>
                </div>
            </div>
            <div className="form-group row" id="div_municipalityId">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.municipality)}</b>
                </label>
                <div className="col-sm-10">
                    <Field
                        name="municipalityId"
                        component={Municipality}
                        municipalities={municipalities}
                    >
                    </Field>
                </div>
            </div>
            <div className="form-group row" id="div_addressId">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.address)}</b>
                </label>
                <div className="col-sm-10">
                    <Field
                        name="addressId"
                        component={CompanyAddress}
                        addressSearchResult={addressSearchResult}
                        regionId={initialValues.regionId}
                        municipalityId={initialValues.municipalityId}
                        addressPreLoaded={initialValues.addressPreLoaded}
                        addressId={initialValues.addressId}
                    />
                </div>
            </div>
            <Field
                className="form-control"
                name="city"
                type="text"
                component={ValidatedWrappedInputField}
                label={intl.formatMessage(messages.city)}
                // readOnly={true}
            />
            <Wrapper
                label={intl.formatMessage(messages.postalCode)}
                // error={this.getFieldError('postalCode')}
            >
                <div className={'row'}>
                    <div className="w-3 ml-2 pt-2">DK</div>
                    <div className="col-xs col-sm-4 col-xl-2">
                        <Field
                            className="form-control"
                            name="postalCode"
                            component={'input'}
                            type="text"
                            placeholder="XXXX"
                            // readOnly={true}
                            normalize={normalizePostalCode}
                        />
                    </div>
                </div>
            </Wrapper>
            <div className="form-group row mt-2">
                <label className="col-sm-2">
                    <b>{intl.formatMessage(messages.showAddressOnMap)}</b>
                </label>
                <div className="col-sm-10">
                    <label className="custom-control custom-checkbox">
                        <Field
                            name="showOnGoogleMaps"
                            type="checkbox"
                            component="input"
                            className="custom-control-input"
                        />
                        <span className="custom-control-indicator"> </span>
                    </label>
                </div>
            </div>
            <GeoLocation
                addressId={initialValues.addressId}
                latitude={initialValues.latitude}
                longitude={initialValues.longitude}
            />

            <hr/>

            <Price/>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.statistic)}</b>
                </label>
                <div className="col-sm-10 m-t-5">
                    <label className="custom-control custom-checkbox m-0">
                        <Field
                            type="checkbox"
                            name="isStatistic"
                            component="input"
                            className="custom-control-input"
                        />
                        <span className="custom-control-indicator"/>
                        <span className="custom-control-description">
                            {intl.formatMessage(messages.sendStatisticToContactPerson)}
                        </span>
                    </label>
                </div>
            </div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.comments)}</b>
                </label>
                <div className="col-sm-10 m-t-5">
                    <label className="custom-control custom-checkbox m-0">
                        <Field
                            type="checkbox"
                            name="isCommentsAllowed"
                            component="input"
                            className="custom-control-input"
                        />
                        <span className="custom-control-indicator"/>
                        <span className="custom-control-description">
                           {intl.formatMessage(messages.courseAllowComments)}
                        </span>
                    </label>
                </div>
            </div>
            <hr />

            <Field
                type="text"
                name="description"
                component={RteEditor}
                placeholder={intl.formatMessage(messages.descriptionPlaceholder)}
                isUpdate={isUpdate}
            />

            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.images)}</b>
                    {' ' + intl.formatMessage(messages.optional)}
                    <small className="form-text text-muted">
                        {`${intl.formatMessage(messages.filesMaxSize)} ${imageSizeLimit} MB.`}
                    </small>
                </label>
                <div className="col-sm-10">
                    <Fields
                        type="file"
                        names={[
                            'images',
                            'defaultImages',
                            'defaultImageIds',
                        ]}
                        component={FileUpload}
                        props={{
                            postUrl: 'api/privateV1/courses/validate-images',
                            maxFiles: 1,
                            type: 'image'
                        }}
                    />
                </div>
            </div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label">
                    <b>{intl.formatMessage(messages.catalogs)}</b>
                    {intl.formatMessage(messages.optional)}
                    <small className="form-text text-muted">
                        {`${intl.formatMessage(messages.filesMaxSize)} ${fileSizeLimit} MB.`}
                    </small>
                </label>
                <div className="col-sm-10">
                    <Fields
                        type="file"
                        names={[
                            'files',
                            'defaultFiles',
                            'defaultFileIds',
                        ]}
                        component={FileUpload}
                        props={{
                            postUrl: 'api/privateV1/courses/validate-files',
                            type: 'file'
                        }}
                    />
                </div>
            </div>
            <Fields
                type="text"
                names={[
                    'youtubeId',
                    'vimeoId',
                    'vimeoName',
                    'vimeoDescription',
                ]}
                component={VideoUploadRedux}
            />

            <hr />
            <Field
                className="form-control"
                name="additionalInformation"
                type="text"
                placeholder="http://"
                component={ValidatedInputField}
                label={intl.formatMessage(messages.additionalInformation)}
                hint={
                    <small className="form-text text-muted">
                       {intl.formatMessage(messages.courseAdditionalInformationDescription)}
                    </small>
                }
            />
            <Field
                className="form-control"
                name="registrationLink"
                type="text"
                placeholder="http://"
                component={ValidatedInputField}
                label={intl.formatMessage(messages.courseRegistration)}
                hint={
                    <small className="form-text text-muted">
                        {intl.formatMessage(messages.courseRegistrationDescription)}
                    </small>
                }
            />
            <hr/>
            <div className="form-group row">
                <div className="col-sm-12">
                    <div className="offset-sm-2">
                        <SubmitButton isCourse={true} isUpdate={isUpdate}/>
                        <ResetButton onClick={handleReset}/>
                    </div>
                </div>
            </div>
        </form>
    )
};

CourseFormRedux = reduxForm({
    form: 'courses',
    validate,
    onSubmitFail: afterSubmitFail
})(CourseFormRedux);

export default injectIntl(CourseFormRedux);


// WEBPACK FOOTER //
// ./web/src/components/venues-and-courses/CoursesFormRedux.jsx